export default class {
  constructor () {
      this.icon = null;
      this.menu = null;
      this.menuClose = null;
      this.menuOpen = null;
      this.header = null;
  }

  init () {
    this.icon = document.querySelector('.header__menuIcon');
    this.menu = document.querySelector('.header__drawer');
    this.menuClose = document.querySelector('.header__closeIcon');
    this.menuOpen = document.querySelector('.header__menuIcon');
    this.header = document.querySelector('.header');
    this.item = document.querySelectorAll('.header__drawerMenuList');

    this.addEvent();
  }

  addEvent () {
    this.icon.addEventListener('click', () => {
      if (this.menu.classList.value === 'header__drawer') {
        this.menu.classList.add('header__drawer--open');
        this.menuOpen.classList.add('header__menuIcon--close');
        this.menuClose.classList.add('header__closeIcon--open');
      };
    });

    this.menuClose.addEventListener('click', ()=> {
      this.menu.classList.remove('header__drawer--open');
      this.menuClose.classList.remove('header__closeIcon--open');
      this.menuOpen.classList.remove('header__menuIcon--close');
    });

    for (let i = 0; i < this.item.length; i++) {
      this.item[i].addEventListener('click', ()=> {
        this.menu.classList.remove('header__drawer--open');
        this.menuClose.classList.remove('header__closeIcon--open');
        this.menuOpen.classList.remove('header__menuIcon--close');
      });
    }
  }
};
